module.exports = __webpack_public_path__ + "static/emma-b0e74a855aff3492d3200ad2760df734.jpg";